import { render } from "./GroupAdminPage.vue?vue&type=template&id=0f70c5f3&scoped=true"
import script from "./GroupAdminPage.vue?vue&type=script&lang=js"
export * from "./GroupAdminPage.vue?vue&type=script&lang=js"

import "./GroupAdminPage.vue?vue&type=style&index=0&id=0f70c5f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.108.4_postcss@8.5.18_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f70c5f3"]])

export default __exports__